import { render, staticRenderFns } from "./agree-common.vue?vue&type=template&id=e85207ee&scoped=true&"
import script from "./agree-common.vue?vue&type=script&lang=ts&"
export * from "./agree-common.vue?vue&type=script&lang=ts&"
import style0 from "./agree-common.vue?vue&type=style&index=0&id=e85207ee&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e85207ee",
  null
  
)

export default component.exports